angular.module('impactx.customerservice').service('CustomerService', [
    'dataGen',
    '$route',
    CustomerService
]);

function CustomerService(dataGen, $route) {
    var self = this;
    self.data = {
        isPanelOpen: false
    };

    function getDialogData () {
        return dataGen.getData({}, {}, '/customerservice/init').then(function (result) {
            handleReasonPreselection(result.data);
            return {
                data: result.data,
                trns: result.trns
            };
        });
    }

    function send(data) {
        return dataGen.postAsForm({}, {data: data}, '/customerservice/send');
    }

    function openPanel() {
        self.data.isPanelOpen = true;
    }

    function closePanel() {
        self.data.isPanelOpen = false;
    }

    function handleReasonPreselection(data) {
        var currentRoute = $route.current.$$route.originalPath;
        if (currentRoute.indexOf('search') >= 0) {
            data.reasons.setId = 0;
        }
        else if (currentRoute.indexOf('vcatalog') >= 0 || currentRoute.indexOf('product') >= 0) {
            data.reasons.setId = 1;
        }
        else {
            data.reasons.setId = 2;
        }
    }

    return {
        data: self.data,
        getDialogData: getDialogData,
        send: send,
        openPanel: openPanel,
        closePanel: closePanel,
    };
}
